/*
  Pelletteria Marant — menu header: chiusura rapida all'uscita (28/09/2026)
  ------------------------------------------------------------
  Comportamento Prestige di serie: uscito dal menu, aspetta 250 ms
  (mouseOverDelayTolerance) e poi dissolve in 0,4 s. Rientrando in quella
  finestra il menu ripartiva da opacità 0 e sembrava "sparire e riapparire".

  Richieste Matteo (28/09): il menu deve sparire appena si esce, con una
  dissolvenza brevissima. Per dropdown e mega menu:

  1. Tolleranza di uscita HOVER_TOLERANCE_MS. NON può essere 0: tra la voce
     della nav e il pannello c'è la fascia di padding dell'header, che non
     appartiene al menu. Con 0 ms il menu si chiudeva mentre ci si passava
     sopra (provato il 28/09). Rientrando entro questo tempo il timer si
     annulla e il menu resta aperto.

  2. Dissolvenza di chiusura FADE_OUT_S (di serie 0,4 s). Il tema toglie
     'open' a fine animazione, come prima.

  3. Se si rientra DURANTE la dissolvenza, l'apertura riparte dall'opacità
     corrente ([null, 1] = valore attuale per Motion) e salta lo stagger
     delle voci, già visibili: niente sfarfallio. In tutti gli altri casi
     resta l'animazione di apertura originale del tema.

  'vendor' è la stessa istanza di Motion usata dal tema: una nuova animazione
  sullo stesso elemento ferma la precedente, e il finished della chiusura
  interrotta si risolve con undefined, quindi il tema NON toglie 'open'.
  theme.js non viene toccato.

  Regolazioni: se il menu si chiude attraversando lo spazio verso il pannello,
  alzare HOVER_TOLERANCE_MS (es. 200); non scendere sotto ~100.
*/
import { timeline } from 'vendor';

const HOVER_TOLERANCE_MS = 150;
const FADE_OUT_S = 0.12;
const RESUME_FADE_IN_S = 0.15;

const CLOSING = Symbol('mrntClosing');

function patchMenu(tagName) {
  const ctor = customElements.get(tagName);
  if (!ctor || ctor.prototype.__mrntHoverFix) return;

  const proto = ctor.prototype;
  const originalShow = proto.createShowAnimationControls;

  Object.defineProperty(proto, 'mouseOverDelayTolerance', {
    configurable: true,
    get() {
      return HOVER_TOLERANCE_MS;
    }
  });

  proto.createHideAnimationControls = function () {
    this[CLOSING] = true;
    return timeline([[this.contentElement, { opacity: [null, 0] }, { duration: FADE_OUT_S }]]);
  };

  proto.createShowAnimationControls = function () {
    const content = this.contentElement;
    const wasClosing = this[CLOSING] === true;
    this[CLOSING] = false;

    if (wasClosing && parseFloat(getComputedStyle(content).opacity) > 0.02) {
      return timeline([[content, { opacity: [null, 1] }, { duration: RESUME_FADE_IN_S }]]);
    }
    return originalShow.call(this);
  };

  proto.__mrntHoverFix = true;
}

['dropdown-menu-disclosure', 'mega-menu-disclosure'].forEach((tag) => {
  customElements.whenDefined(tag).then(() => patchMenu(tag));
});
